import MainTable, { MainTableColumn } from '@/components/company/table/MainTable';
import { IChecklistLog } from '@/types/checklist.types';
import { DataConfig } from '@/utils/hooks/useDefaultDataConfig';
import { formatDistanceToNow } from 'date-fns';
import { id as idLocale } from 'date-fns/locale';

interface LogHistoryTableProps {
  isLoading: boolean;
  logs: IChecklistLog[];
  totalItems: number;
  totalPages: number;
  pageConfig: DataConfig;
  setPageConfig: React.Dispatch<React.SetStateAction<DataConfig>>;
}

const getActionLabel = (action: string): string => {
  const actionMap: Record<string, string> = {
    instance_created: 'Instance dibuat',
    instance_submitted: 'Instance disubmit',
    instance_reviewed: 'Instance direview',
    confirmation_added: 'Konfirmasi ditambahkan',
    confirmation_updated: 'Konfirmasi diupdate',
    response_created: 'Response dibuat',
    response_updated: 'Response diupdate',
    response_status_changed: 'Merubah Status Checklist',
    response_completed: 'Response selesai',
    response_documents_added: 'Dokumen ditambahkan',
    response_documents_removed: 'Dokumen dihapus',
    response_media_added: 'Media ditambahkan',
    response_media_removed: 'Media dihapus',
    weekly_reminder_sent: 'Pengingat mingguan dikirim',
  };
  return actionMap[action] || action;
};

export default function LogHistoryTable({
  isLoading,
  logs,
  totalItems,
  totalPages,
  pageConfig,
  setPageConfig,
}: LogHistoryTableProps) {
  const columns: MainTableColumn[] = [
    {
      name: 'action',
      label: 'Aksi',
      render: (action: string) => (
        <span className="text-sm text-gray-900 dark:text-gray-100">{getActionLabel(action)}</span>
      ),
    },
    {
      name: 'actor_name',
      label: 'Pelaku',
      render: (_: unknown, row: IChecklistLog) => (
        <div>
          <div className="font-medium text-gray-900 dark:text-gray-100">{row.actor_name}</div>
          <div className="text-xs text-gray-500 dark:text-gray-400">{row.actor_role}</div>
        </div>
      ),
    },
    {
      name: 'notes',
      label: 'Catatan',
      render: (notes: string) => <div className="max-w-xs dark:text-gray-100">{notes || '-'}</div>,
    },
    {
      name: 'created_at',
      label: 'Waktu',
      render: (createdAt: string) => (
        <div className="text-xs text-gray-600 dark:text-gray-400">
          {formatDistanceToNow(new Date(createdAt), {
            addSuffix: true,
            locale: idLocale,
          })}
        </div>
      ),
    },
  ];

  return (
    <MainTable
      showHeader={false}
      isLoading={isLoading}
      data={{
        content: logs as unknown as { [key: string]: unknown }[],
        totalElements: totalItems,
        totalPages: totalPages,
      }}
      columns={columns}
      pageConfig={pageConfig}
      setPageConfig={setPageConfig}
      showActions={false}
    />
  );
}
